export const DEFAULT_UID_NAMESPACE = "f7f5971e-7461-49c4-b763-c2443408c07f";
